import React from 'react';
import Popup from '../common/components/Popup';
import PopupWarningContent from './PopupWarningContent';

interface resetPasswordPopupProps {
    showPopup: boolean,
    onClose: (show: boolean) => void,
}

function ResetPasswordPopup(props: resetPasswordPopupProps) {
    const {showPopup, onClose} = props;

    return (
        <Popup
            show={showPopup}
            onClose={() => onClose(false)}
            title='Are you sure you want to reset password?'
            size='lg'
            primaryCtaText='Reset Password'
            primaryCtaOnClick={() => false}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => false}
            customClassName='manage-user-menu-popup'
        >
            <PopupWarningContent mainContent='A password reset link will be sent to the following user' subContent='johndoe@hub.com'/>
        </Popup>
    );
}

export default ResetPasswordPopup;
